export const PRICELIMIT = 6000;
export const PAGESIZE = 25;

export const OFFERSPERREQUEST = 25;
export const OFFERSATFIRSTREQUEST = 25;

export const DEBOUNCEFILTERTIME = 100;
export const DEBOUNCEFILTERSLIDERTIME = 50;

export const FILTERDISPLAYAMOUNT = 5;
